import WithBlaze from '../Products/WithBlaze';
import BrandCard from './BrandCard';
import { blazeConfigCategories } from '../../config';

const BrandCards = ({
    brandImages,
    menuSlug,
    rootId,
    slider,
    isMenuPage,
    setSelectedFilters,
    sliderBreakpoints,
}) => {
    return (
        <div
            className={`headless-products-container ${
                slider
                    ? 'headless-slider headless-loop-slider blaze-slider no-filter'
                    : ''
            }`}
            data-blaze={slider ? JSON.stringify(blazeConfigCategories(sliderBreakpoints)) : null}
        >
            {slider || isMenuPage ? (
                <WithBlaze rootId={rootId}>
                    {Object.entries(brandImages).map(([brand, img]) => (
                        <BrandCard
                            key={brand + '-card'}
                            brand={brand}
                            image={img}
                            menuSlug={menuSlug}
                            isMenuPage={isMenuPage}
                            setSelectedFilters={setSelectedFilters}
                        />
                    ))}
                </WithBlaze>
            ) : (
                <>
                    {Object.entries(brandImages).map(([brand, img]) => (
                        <BrandCard
                            key={brand + '-card'}
                            brand={brand}
                            image={img}
                            menuSlug={menuSlug}
                            isMenuPage={isMenuPage}
                            setSelectedFilters={setSelectedFilters}
                        />
                    ))}
                </>
            )}
        </div>
    );
};

export default BrandCards;
